import { Observable, throwError } from 'rxjs';

import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { WordpressPaging } from '@app/enums/_index';
import { StaticPageInterface } from '@app/interfaces/static-page.interface';
import { getCacheBustedParams } from '@app/utilities/cacheBustedHttpParams.utilities';
import { environment } from '@environments/environment';
import { catchError } from 'rxjs/operators';
import { ErrorHandlerService } from '../shared/error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class TermsAndConditionsService extends ErrorHandlerService {
  private termsAndConditionsURL = `${environment.cms.url}/wp-json/wp/v2/pages`;

  constructor(private http: HttpClient) {
    super();
  }

  /**
   * Returns the terms and conditions from the wordpress API
   * @returns Terms and Conditions observable response
   */
  getTermsAndConditions(pageId?: number): Observable<StaticPageInterface[]> {
    let ContentParams = getCacheBustedParams().append(
      WordpressPaging.PER_PAGE_KEY,
      WordpressPaging.PER_PAGE_VALUE
    );
    if (pageId) {
      ContentParams = ContentParams.append('include', pageId.toString());
    }
    return this.http.get(`${this.termsAndConditionsURL}`, { params: ContentParams }).pipe(
      catchError((err) => {
        console.log(`Service error has occurred`, err);
        return throwError(() => new Error(err));
      }),
      catchError(this.handleError<StaticPageInterface>('getTermsAndConditions'))
    );
  }
}
